import { faCheck, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip } from '@ui';
import { IBANDetailsType, useIBANValidation } from 'hooks/useIBANValidation';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import FormInput from './FormInput';

interface Props {
    size?: any;
}

export const FormIBAN = ({ name, label, ...props }: Props & Omit<React.ComponentProps<typeof FormInput>, 'size'>) => {
    const { setError, clearErrors, watch } = useFormContext();
    const value = watch(name);
    const { isLoading, validate, ibanDetails } = useIBANValidation({
        onInvalid() {
            setError(name, {
                type: 'manual',
                message: 'Deine IBAN weist Fehler auf! Bitte überprüfe deine Eingaben.'
            });
        },
        onValid() {
            clearErrors(name);
        }
    });

    useEffect(() => validate(value), [value]);

    return (
        <FormInput
            onChange={(e) => validate(e.target.value)}
            label={label}
            name={name}
            contentRight={
                <Tooltip placement="left" tooltip={<IBANDetails details={ibanDetails} />}>
                    <Button
                        isLoading={isLoading}
                        icon={<FontAwesomeIcon icon={ibanDetails?.valid ? faCheck : faExclamationTriangle} />}
                        disabled={isLoading}
                        color={ibanDetails?.valid ? 'success' : 'error'}
                        size="xs"
                    />
                </Tooltip>
            }
            {...props}
        />
    );
};

const IBANDetails = ({ details }: { details: IBANDetailsType }) => (
    <div className="p-2" style={{ width: '300px' }}>
        <h5>Details</h5>
        <div className="row">
            <div className="col-sm-6 text-right">Status</div>
            <div className={`col-sm-6 ${details?.valid ? 'text-success' : 'text-danger'}`}>
                {details?.valid ? 'VALIDE' : 'FEHLERHAFT'}
            </div>
        </div>
        <div className="row">
            <div className="col-sm-6 text-right">BIC</div>
            <div className="col-sm-6">{details?.bankData.bic || '-'}</div>
        </div>
        <div className="row">
            <div className="col-sm-6 text-right">Name der Bank</div>
            <div className="col-sm-6">{details?.bankData.name || '-'}</div>
        </div>
        <div className="row">
            <div className="col-sm-6 text-right">Stadt</div>
            <div className="col-sm-6">{details?.bankData.city || '-'}</div>
        </div>
        {details?.messages?.length > 0 && (
            <>
                <hr className="my-4" />
                <h5>Fehler</h5>
                {details.messages?.map((message, index) => (
                    <p key={`iban_error_message_${index}`}>{message}</p>
                ))}
            </>
        )}
    </div>
);
